import { MessageResponseDto } from "@api/api";
import { registrationFormDefault } from "@factory/form/form.default";
import {
  RegistrationFormRule,
  RegistrationFormSchema,
} from "@factory/form/form.rule";
import { useQyCreateRegistration } from "@factory/query/registration.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { useState } from "react";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";

import { appConfig } from "../../../app.config";

export function useNewRegistration() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateRegistration } = useFormApiMapper();
  const { showError } = useNotificationContext();
  const { client } = useParams();
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const logo = `${
    appConfig.bucketAssetPath
  }/${client}/icon-192x192.png?${new Date().toISOString()}`;

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    setShowSuccessModal(true);
    navigate(`./`);
  };
  const { mutate: addRegistration, isLoading: isCreating } =
    useQyCreateRegistration(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<RegistrationFormSchema>({
    defaultValues: registrationFormDefault,
    resolver: zodResolver(RegistrationFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: RegistrationFormSchema) => {
    const updatedForm = {
      ...form,
      tenant: client,
    };
    const formData = mapCreateRegistration(updatedForm);
    addRegistration(formData);
  };
  const handleValidateError = (err: FieldErrors<RegistrationFormSchema>) => {
    const formMessage = "Please fill in required fields";
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
    showSuccessModal,
    setShowSuccessModal,
    logo,
  };
}
